import {getPresentColumnsData, getSettings} from "~/stateGetter";
import saveSettings from "~/backend/saveSettings";
import {isColumnHidden, presentRouteViews} from "~/statePresenter";
import {getFilterValue, getModel, getResultsState, getTableSettingsIdentifier,} from "../stateGetter";

import { push, replace } from 'redux-little-router';
import { batch } from "~/redux/connect";
import { getFitleredViewState } from "~/StateGetters/FilteredViewStateGetters";
import { modelActionsCreator } from "./model_actions";
import identify from "~/identify";
import { encodeURI } from "js-base64/base64";
import debounce from "lodash/debounce";



export const SETTINGS_ACTIONS = {
    CHANGE_COLUMN_VISIBILITY: 'settings_change_column_visibility',
    CHANGE_SORT: 'settings_change_sort',
    CHANGE_PER_PAGE: 'settings_change_per_page',
    CHANGE_COLUMN_WIDTHS: 'settings_change_column_widths',
    CHANGE_GROUP_OPEN: 'settings_change_group_open',
    CHANGE_FILTER_OPEN: 'settings_change_filter_open',
    CHANGE_COLUMN_ORDER: 'settings_change_column_order',
    CHANGE_FILTER_ORDER: 'settings_change_filter_order',
    RESET_FILTERS: 'settings_reset_filters',
    RESET_COLUMNS: 'settings_reset_columns',
    CHANGE_TOOLTIPS_ACTIVE: 'change_tooltips_active',
    CHANGE_CALENDAR_VIEW_SETTINGS: 'change_calendar_view_settings',


    APPLY_ACTIVE_VIEW: "apply_active_view",
    RESET_FILTERED_VIEW: "reset_active_view",
    SET_ACTIVE_FILTERED_VIEW: "set_active_view",
    DUPLICATE_FILTERED_VIEW: "duplicate_current_view",
    RENAME_FILTERED_VIEW: "change_view_name",
    DELETE_FILTERED_VIEW: "delete_view",
    GO_TO_FILTERED_VIEW: "go_to_view",
    SHARE_FILTERED_VIEW: "share_view",
    UPDATE_FILTER: "update_view_filter",
    UPDATE_FILTER_ORDER: "update_view_filter_order",
    SAVE_VIEWS: "save_views",
};


function wrapSettingsAction(action) {
    return (dispatch, getState) => {
        dispatch(action);

        let state = getState();
        let settings = getSettings(state);

        return saveSettings(settings);
    }
}


export function changeFilterOrder(identifier, filterOrder) {
    return wrapSettingsAction((dispatch, getState) => {
        dispatch({
            type: SETTINGS_ACTIONS.CHANGE_FILTER_ORDER,
            filterOrder,
            identifier,
        });
    });
}



export function changeGroupOpen(identifier, groupName, open) {
    return wrapSettingsAction({
        type: SETTINGS_ACTIONS.CHANGE_GROUP_OPEN,
        identifier, open, groupName
    });
}


export function changeFilterOpen(identifier, groupName, filterName, open) {
    return wrapSettingsAction({
        type: SETTINGS_ACTIONS.CHANGE_FILTER_OPEN,
        identifier, open, groupName, filterName
    });
}


export function resetFilters(identifier) {
    return wrapSettingsAction({
        type: SETTINGS_ACTIONS.RESET_FILTERS,
        identifier
    })
}


export function changeTooltipsActive(active) {
    return wrapSettingsAction({ type: SETTINGS_ACTIONS.CHANGE_TOOLTIPS_ACTIVE, active });
}


export function settingsActionCreator(modelId, dispatch = (a) => a) {
    const goToViewFunc = (dispatch, getState, view, {shouldReplace = false, shouldRefresh = true} = {}) => { 
        const state = getState(),
                settingsIdentifier = getTableSettingsIdentifier(state, modelId),
                routeView = encodeURI(JSON.stringify({ ...presentRouteViews(state), [settingsIdentifier]: {...view }, }));

        batch(() => {
            const action = shouldReplace ? replace : push; 
            dispatch(action(`/${settingsIdentifier}/views/${routeView}`));
            shouldRefresh && dispatch(hideMessages());
        })
    }




    const debouncedGoToView = debounce(goToViewFunc, { trailing: true })

    
    
    const goToView = ({view}, navigationProps = {}) => (dispatch, getState) => {
        const params = [dispatch, getState, view, navigationProps];

        if (navigationProps?.throttle !== false ) { return debouncedGoToView(...params) }
        return goToViewFunc(...params);
    };



    const maybeSaveSettings = (action, modelId) => {
        return (dispatch, getState) => {
            batch(() => {
                dispatch(action);
                if (!getModel(getState(), modelId).parentModelId) {
                    return;
                }
                
                dispatch(wrapSettingsAction({ type: SETTINGS_ACTIONS.SAVE_VIEWS, modelId }))
            })
        }
    }


    const maybeUpdateURL = (action, navigationProps) => (dispatch, getState) => batch(() => {
        dispatch(action);

        const model = getModel(getState(), modelId);
        if (!model.parentModelId) {
            dispatch(goToView({view: getFitleredViewState(getState(), modelId).getWorkingView() }, navigationProps));
        }
    });


    const pushWorkingViewToURL = (action, navigationProps) => (dispatch, getState) => {
        dispatch(action);

        const model = getModel(getState(), modelId);
        if (!model.parentModelId) {
            dispatch(goToView({ view: getFitleredViewState(getState(), modelId).getWorkingView() }, { shouldReplace: true, ...navigationProps }));
        }
    };




    const setActiveView = ({ view }) => ({
        type: SETTINGS_ACTIONS.SET_ACTIVE_FILTERED_VIEW,
        modelId,
        view
    });



    const changeCalendarViewConfig = (configName, value) => ({
        type: SETTINGS_ACTIONS.CHANGE_CALENDAR_VIEW_SETTINGS,
        modelId,
        configName,
        value,
    })




    const hideMessages = () => (dispatch, getState) => {
        if (getResultsState(getState(), modelId).status !== identify.STATUS_ERRORED) { return }
        dispatch(modelActionsCreator(modelId).hideMessages())
    };

    const updateFilterOrder = (name) => (dispatch) => {
        const updateOrder = () => pushWorkingViewToURL({
            name,
            modelId,
            type: SETTINGS_ACTIONS.UPDATE_FILTER_ORDER,
        }, { throttle: false });


        return dispatch(wrapSettingsAction(updateOrder()))
    }

    
    return {
        goToView,

        renameView: ({view, title, previousTitle}) => wrapSettingsAction(
            maybeUpdateURL({
                type: SETTINGS_ACTIONS.RENAME_FILTERED_VIEW,
                view, title,
                modelId,
                previousTitle
            }, { shouldRefresh: false })
        ),



        duplicateView: () => wrapSettingsAction(
            maybeUpdateURL({
                type: SETTINGS_ACTIONS.DUPLICATE_FILTERED_VIEW,
                modelId,
            })
        ),


        
        deleteView: ({view}) => wrapSettingsAction((dispatch, getState) => {
            const filterViewState = getFitleredViewState(getState(), modelId),
                  lastActiveView = filterViewState.activeFilteredViewName,
                  count = filterViewState.count;

            dispatch({
                type: SETTINGS_ACTIONS.DELETE_FILTERED_VIEW,
                modelId,
                view,
            })

            const newView = getFitleredViewState(getState(), modelId).getActiveView();
            if (lastActiveView !== newView?.viewKey || count <= 1) {
                dispatch(goToView({ view: newView }, { shouldReplace: true }))
            }
        }),



        shareView: ({view}) => wrapSettingsAction(
            maybeUpdateURL({
                type: SETTINGS_ACTIONS.SHARE_FILTERED_VIEW,
                modelId,
                view,
            }, { shouldRefresh: false })
        ),


        setActiveView: ({view,}) => wrapSettingsAction(maybeUpdateURL(setActiveView({ view }))),

        saveViews: () => wrapSettingsAction({ type: SETTINGS_ACTIONS.SAVE_VIEWS, modelId }),

        changeColumnWidths(columnWidths) {
            return maybeSaveSettings(
                maybeUpdateURL({
                    type: SETTINGS_ACTIONS.CHANGE_COLUMN_WIDTHS,
                    modelId,
                    columnWidths,
                }, { shouldRefresh: false }),
                modelId
            )

        },

        changeColumnOrder(columnOrder) {
            return maybeSaveSettings(
                maybeUpdateURL({
                    type: SETTINGS_ACTIONS.CHANGE_COLUMN_ORDER,
                    modelId,
                    columnOrder,
                })
                , modelId
            );
        },

        changePerPage(perPage) {
            return maybeSaveSettings(
                maybeUpdateURL({
                    type: SETTINGS_ACTIONS.CHANGE_PER_PAGE,
                    modelId,
                    perPage
                })
                , modelId
            );
        },

        resetColumns() {
            return maybeSaveSettings(
                    maybeUpdateURL({
                    type: SETTINGS_ACTIONS.RESET_COLUMNS,
                    modelId,
                })
                , modelId
            );
        },

        changeSort(sort) {
            return maybeSaveSettings(
                maybeUpdateURL({
                    type: SETTINGS_ACTIONS.CHANGE_SORT,
                    modelId,
                    sort,
                })
                , modelId
            );
        },

        updateCalendarView(view) {
            return maybeUpdateURL(changeCalendarViewConfig("view", view))
        },

        toggleCalendarView(isEnabled) {
            return maybeUpdateURL(changeCalendarViewConfig("enabled", isEnabled))
        },

        toggleColumnVisibility(columnName) {
            return maybeUpdateURL((dispatch, getState) => {
                let state = getState(),
                    props = getPresentColumnsData(state, modelId);
        
                
                dispatch({
                    type: SETTINGS_ACTIONS.CHANGE_COLUMN_VISIBILITY,
                    columnName,
                    modelId,
                    visible: isColumnHidden(columnName, props)
                });
            });
        },


        updateFilter: (name, value, {autoUpdateFilterOrder, ...props} = {}) => (dispatch) => {
            if(autoUpdateFilterOrder) dispatch(updateFilterOrder(name));
            dispatch(
                pushWorkingViewToURL({
                    name,
                    value,
                    modelId,
                    props,
                    type: SETTINGS_ACTIONS.UPDATE_FILTER,
                }, { throttle: false })
            )
        },


        updateFilterOrder,


        resetFieldValue: (name, props) => pushWorkingViewToURL({
            name,
            modelId,
            props,
            type: SETTINGS_ACTIONS.UPDATE_FILTER,
        }, { throttle: false }),



        pushViewToURL(action) {
            return (dispatch, getState) => {
                
                // batch(() => {
                //     const state = getState(),
                //           modelStateInfo = getAllResultStateInfos(state, modelId),
                //           filteredViewState = getFitleredViewState(state, modelId),
                //           isSharedView = filteredViewState.isSharedView(),
                //           activeFilters = filteredViewState.getActiveView().filters;

                    dispatch(action);

                //     const filterValues = getFilterValues(getState(), modelId),
                //         appliedFilters = presentAppliedFilterValuesObject({...modelStateInfo, filterValues });
                    
                //     if (isEqual(activeFilters, appliedFilters)) {
                //         return;
                //     }

                //     dispatch(hideMessages(modelStateInfo.resultState))

                //     if (isSharedView) { return; }
                // })
            }
        }
    }
}